export type CustomerBookingKind = 'photo' | 'styling';

export type CustomerBooking = {
    id: string;
    kind: CustomerBookingKind;
    orderId: number;
    orderCollectionNumber: string;
    orderNumber: number;
    start: string;
    end: string;
    product: string | null;
    address: string | null;
    postalNumber: string | null;
    city: string | null;
    performedBy: string | null;
    brokerAgentName: string | null;
    brokerFirmName: string | null;
    createdBy: string | null;
    isOwn: boolean;
    brokerAgentId: number | null;
    calendarItemId: number;
    canRebook: boolean;
    isRebookLocked: boolean;
    rebookPath: string | null;
    canCancel: boolean;
    planOrderId: number | null;
    planOrderNumber: string | null;
};

export type CalendarBroker = {
    id: number;
    name: string;
};

export type UnbookedOrder = {
    orderId: number;
    orderCollectionNumber: string;
    orderNumber: number;
    kind: CustomerBookingKind;
    orderedAt: string;
    product: string | null;
    address: string | null;
    postalNumber: string | null;
    city: string | null;
    brokerAgentId: number | null;
    brokerAgentName: string | null;
    brokerFirmName: string | null;
    isOwn: boolean;
    listing: 'bookable' | 'awaiting-se360';
    bookingPath: string | null;
};

export type UnbookedOrders = {
    mayBook: boolean;
    orders: UnbookedOrder[];
};

export type BookingRange = {
    start: string;
    end: string;
};

export enum CancellationTiming {
    Normal = 0,
    Late = 1,
    SameDay = 2,
    AfterBookingDay = 3
}
